module.exports = __webpack_public_path__ + "img/1-8-3.77c3e1ee.png";